import { IReviewApiCall, IRestApiService, ReviewData, Review, PendingReview, PendingReviewResponse } from '../types';

class ReviewApiCall implements IReviewApiCall {
  private restApiService: IRestApiService;

  constructor(restApiService: IRestApiService) {
    this.restApiService = restApiService;
  }

  getVooptyReviews(studioId: string): Promise<Review[]> {
    return this.restApiService.get(`review/studio/get/${studioId}`);
  }

  getClientReviews(studioId: string): Promise<Review[]> {
    return this.restApiService.get(`review/studio/get/client/${studioId}`);
  }

  getPendingReview(id: string): Promise<PendingReviewResponse> {
    return this.restApiService.get(`pending-review/${id}`);
  }

  getPendingReviewForClient(ownerId: string, studioClientId: string): Promise<PendingReviewResponse> {
    return this.restApiService.get(`pending-review/get-client/${ownerId}/${studioClientId}`);
  }

  submitReview(id: string, data: ReviewData): Promise<any> {
    return this.restApiService.put(`pending-review/${id}`, data);
  }

  addClientReview(data: ReviewData): Promise<Review> {
    return this.restApiService.post('review/studio', { review: data });
  }

  rejectReview(id: string): Promise<any> {
    return this.restApiService.put(`pending-review/${id}/reject`);
  }
}

export default ReviewApiCall;
